module.exports = __webpack_public_path__ + "static/psychology-of-human-relationships-f7e7acb4ab0614b344bb3caed64ca218.webp";